import { render, staticRenderFns } from "./TutorDetail.vue?vue&type=template&id=64887b39&scoped=true"
import script from "./TutorDetail.vue?vue&type=script&lang=ts"
export * from "./TutorDetail.vue?vue&type=script&lang=ts"
import style0 from "./TutorDetail.vue?vue&type=style&index=0&id=64887b39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64887b39",
  null
  
)

export default component.exports